export const getEntranceTypeOptions = () => ({
  options: [
    { name: "admission", value: "admission", label: "Admissão" },
    { name: "transfer", value: "transfer", label: "Transferência" },
    { name: "intern_to_full", value: "intern_to_full", label: "Efetivação" },
    { name: "others", value: "others", label: "Outras" },
  ],
  defaultEntranceType: "admission",
});

export const getWorkTypeOptions = () => [
  { name: "hybrid", value: "hybrid", label: "Híbrido" },
  { name: "inoffice", value: "inoffice", label: "Presencial" },
  { name: "remote", value: "remote", label: "Remoto" },
  { name: "unknown", value: "unknown", label: "Não disponível" },
];

export const getGenderOptions = () => ({
  options: [
    { name: "unknown", value: "unknown", label: "Não disponível" },
    { name: "female", value: "female", label: "Feminino" },
    { name: "male", value: "male", label: "Masculino" },
  ],
  defaultGender: "unknown",
});
